export enum authQueryKeys {
  getChangePasswordCode = "get-change-password-code",
}
